// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".url-option-controls[data-v-c3c9de42]{align-items:center;display:flex;gap:6px;margin-top:-2px;min-height:32px}.url-option-btn[data-v-c3c9de42]{letter-spacing:0;text-transform:none;white-space:nowrap}@media(max-width:600px){.url-option-controls[data-v-c3c9de42]{flex-wrap:wrap;max-width:150px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
